<template>
  <v-app class="app">
    <Loading />
    <header>
      <Header />
    </header>
    <main class="main">
      <div class="main__content">
        <h1 class="main__content-title">BSAC JAPAN ショッピング</h1>
        <router-view></router-view>
      </div>
      <MessageDialog />
    </main>
    <footer>
      <Footer />
    </footer>
  </v-app>
</template>

<script>
import Footer from 'vues/common/components/parts/Footer';
import Header from 'vues/common/components/parts/Header';
import Loading from 'vues/common/components/parts/Loading.vue';
import MessageDialog from 'vues/common/components/parts/MessageDialog.vue';

export default {
  components: {
    Footer,
    Header,
    Loading,
    MessageDialog,
  },
  async created() {
    // console.debug(`loginId:` + this.loginId);
    // console.debug(`password:` + this.password);
    if (!this.loginId || !this.password) return;

    this.$store.commit('loading/show');
    try {
      if (this.loginId && this.password) {
        // console.debug('login!');
        let res = await this.$store.dispatch('partner/signin', {
          loginId: this.loginId,
          password: this.password,
        });
        // console.log(`res:${JSON.stringify(res)}`);
        if (res.success) {
          // パートナー情報を取得する
          res = await this.$store.dispatch('partner/getPartner');

          if (res.success) {
            // パートナー情報を注文情報にセットする
            const partner = this.$store.getters['partner/partner'];
            this.$store.commit('shoppingOrder/setApplicationUsingPartner', partner);

            // 商品カテゴリ一覧を取得する
            await this.$store.dispatch('productCategory/getProductCategories');
            // 商品一覧を取得する
            await this.$store.dispatch('product/getProducts');
          } else {
            this.$store.commit('commonMessageDialog/show', res.message);
            await this.$store.dispatch('partner/signout');
          }
        }
      }
    } finally {
      this.$store.commit('loading/close');
    }
  },
  data: function () {
    return {};
  },
  props: {
    loginId: {
      type: String,
    },
    password: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/app-vue.scss';
</style>
